import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { RichText } from "../../models";
import {
  BlockHeader,
  HeaderLevel,
} from "../../../common/block-header/BlockHeader";
import { BlockBody } from "../../../common/block-body/BlockBody";
import { BackgroundColor } from "./enums";

type Props = {
  title: RichText;
  subtitle: RichText;
  backgroundColor?: BackgroundColor;
  isBottomPadding?: boolean;
};

export const SimplifiedHero: FC<Props> = ({
  title,
  subtitle,
  backgroundColor,
  isBottomPadding,
}) => (
  <div
    className={classNames("-mt-20 mb-0 w-full text-primary-content", {
      "bg-dark": backgroundColor === BackgroundColor.GREY,
    })}
  >
    <div
      className={classNames(
        "px-5 pt-34",
        "lg:px-16 lg:pt-45",
        "xl:px-24 xl:pt-60",
        "xxl:mx-auto xxl:max-w-container xxl:px-0",
        {
          "pb-15 lg:pb-25 xl:pb-40": isBottomPadding,
        },
      )}
    >
      <div
        className={classNames(
          "space-y-5",
          "md:max-w-[73%]",
          "xxl:mx-auto xxl:max-w-[66%] xxl:text-center",
        )}
      >
        <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
          <BlockHeader
            richText={title}
            headerLevel={HeaderLevel.H1}
            className={classNames(
              "text-large",
              "lg:text-xx-large",
              "xl:text-huge",
            )}
          />
        </Fade>
        {subtitle ? (
          <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
            <div className={classNames("text-regular")}>
              <BlockBody richText={subtitle} />
            </div>
          </Fade>
        ) : null}
      </div>
    </div>
  </div>
);
